import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import { createBrowserRouter, RouterProvider} from 'react-router-dom';
import { NotFound } from './Components/Error/Notfound';
import { About } from './Components/About /About';
import App from './App';




const router = createBrowserRouter([
  {
  path: '/',
  element: <App />,
  errorElement: <NotFound />
  }, 

  {
    path: "about", 
    element: <About />
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


